<tidy-alert>
  <tidy-row>
    <tidy-image
      (click)="closePopup()"
      [src]="'assets/svg/close-circle.svg'"
      class="title-size align-last-right close-popup-icon"
      style="margin-left: auto;" />
  </tidy-row>
  @if (data?.image) {
    <tidy-row [align]="'center'" style="margin-top: -25px">
      <tidy-image
        [src]="data?.image"
        style="width:70px" />
    </tidy-row>
  }
  <tidy-row [align]="'center'" [ngClass]="data?.addressId ? '' : 'no-bottom-padding'">
    <tidy-text
      [header]="data?.header" />
    @if (data?.body) {
      <br>
        <tidy-text
          [body]="data?.body + (data?.learnMore ? ' ' : '')" />
        @if (data?.body) {
          <tidy-text
            [body]="'Learn More'"
            (action)="goToLink(data?.learnMore)"
            class="link" />
        }
      }
    </tidy-row>
    <tidy-row class="no-bottom-padding" [align]="'center'">
      @if (data?.addressId) {
        <tidy-text
          [body]="'View Address'"
          (action)="goToAddressPage(data?.addressId)"
          class="link" />
      }
    </tidy-row>
  </tidy-alert>
